export default __webpack_public_path__ + "static/media/ServicesBanner.43931592.webp";